import './styles.css';

interface BreadcrumbListProps {
  children: React.ReactNode;
}

export const BreadcrumbList = ({ children }: BreadcrumbListProps) => {
  return (
    <div className="breadcrumb-list-container flex items-center">
      {children}
    </div>
  );
};
